var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mortem container-fluid p-0",staticStyle:{"overflow":"hidden"}},[_c('router-view',{on:{"childrenRoute":_vm.hideNonChildren}}),(!_vm.isChildRoute)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(false)?_c('Report'):_vm._e(),(false)?_c('Overview'):_vm._e(),_c('Slide')],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }